import { diffChars } from 'diff';
export const diff = (initialValue, actualValue) => {
    const diffResultArray = diffChars(actualValue, initialValue, { ignoreCase: true });
    let diffCount = 0;
    diffResultArray.forEach((diffResult, index) => {
        if (diffResult.removed) {
            if (index < diffResultArray.length - 1 && diffResultArray[index + 1].added) {
                diffCount += Math.max(diffResult.count, diffResultArray[index + 1].count);
            }
            else {
                diffCount += diffResult.count;
            }
        }
        else if (diffResult.added && index > 0 && !diffResultArray[index - 1].removed) {
            diffCount += diffResult.count;
        }
    });
    return diffCount;
};
export const arrayContentsDiffer = (a1, a2) => {
    return JSON.stringify(a1) !== JSON.stringify(a2);
};
